import swal from 'sweetalert2'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTrashAlt } from '@fortawesome/pro-light-svg-icons'

import {
  Button, Columns, LoadingModule, SaveFormModule, Tools,
} from '@domain-group/suit-theme'

import { digObject } from '@domain-group/javascript-utils'

import useNotification, { useNotificationForm } from '@hooks/useNotification'

import handleCallbackAction from '@functions/handleCallbackAction'

import NotificationDetails from '../NotificationDetails'
import NotificationImage from '../NotificationImage'
import PageLayout from '../../../../components/PageLayout'

const confirmDelete = (deleteFn: () => void) => {
  const deleteNotificationPayload = {
    callbacks: {
      action: deleteFn,
    },
    shouldRedirect: true,
    toastText: 'Notification Deleted',
  }

  swal
    .fire({
      title: 'Delete Notification?',
      text: 'Are you sure?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it.',
      confirmButtonColor: '#DD6B55',
    })
    .then(({ value }) => {
      if (value){
        // @ts-expect-error TS2345
        handleCallbackAction(deleteNotificationPayload)
      }
    })
}

const PageContent = (props:{ notificationId: number }) => {
  const { notificationId } = props

  const notificationPayload = useNotification({ id: notificationId })
  const {
    callbacks: {
      deleteNotification: deleteFn,
      updateNotification: updateFn,
    },
    deleting,
    loaded,
    loading,
    notification,
    updating,
  } = notificationPayload

  const notificationFormPayload = useNotificationForm(notification, { validateOn: 'change' })
  const { entityState, saveEnabled } = notificationFormPayload

  const updateNotificationPayload = {
    callbacks: {
      action: updateFn,
    },
    entityParams: entityState,
    toastText: 'Notification Updated',
  }

  const location = digObject(entityState, 'options.location')
  const isSidebarNotification = location?.includes('sidebar')

  return (
    // @ts-expect-error TS2741
    <PageLayout entityPayload={notificationPayload}>
      <Columns.Main>
        <LoadingModule loading={loading} times={3} />

        {!loading && loaded && (
          <>
            <NotificationDetails
              isSidebarNotification={isSidebarNotification}
              notificationFormPayload={notificationFormPayload}
            />

            <SaveFormModule>
              <Button
                buttonStyle="primaryCreate"
                disabled={!saveEnabled}
                loading={updating}
                onClick={() => handleCallbackAction(updateNotificationPayload)}
                size="medium"
                style={{ width: '100%' }}
              >
                Save Details
              </Button>
            </SaveFormModule>
          </>
        )}
      </Columns.Main>

      <Columns.Sidebar>
        {isSidebarNotification && (
          <NotificationImage notificationPayload={notificationPayload} />
        )}

        <Tools>
          <Button
            buttonStyle="secondaryUtility"
            icon={<FontAwesomeIcon icon={faTrashAlt} />}
            loading={deleting}
            onClick={() => confirmDelete(deleteFn)}
            size="medium"
          >
            Delete Notification
          </Button>
        </Tools>
      </Columns.Sidebar>
    </PageLayout>
  )
}

export default PageContent
